import type { AxiosResponse } from "axios"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"
import { BaseRepository } from "@/repositories/base-repository"
import type { IWorkspaceAudienceGroup } from "@/workspace/interfaces/api/workspace-audience-group.interface"
import type { IRepositoryRequestConfig } from "@/interfaces/repository/repository-request-config.interface"

export class WorkspaceAudienceGroupRepository extends BaseRepository<IWorkspaceAudienceGroup> {
  protected resourcePath = "workspace/audience-groups"

  public async archive(
    id: string,
    config: IRepositoryRequestConfig = {}
  ): Promise<AxiosResponse<IWorkspaceAudienceGroup>> {
    return await new HTTPRequestBuilder(
      HTTPMethods.POST,
      `${this.getResourcePath(id, config)}archive/`
    )
      .setData({})
      .query(config.query)
      .setbeforeErrorHandlingCallback(config.beforeErrorHandlingCallback)
      .addStatusCodeHandlers(config.statusCodeHandlers)
      .build()
      .execute()
  }
}
